import * as Actions from '../../actions/app/transfer_items.actions'
import { addOrUpdateObjectInArray } from 'utils/add-or-update-object-in-array'
import { toggleIdInArray } from 'utils/toggle-id-in-array'

const initialState = {
  loading_items_by_transfer: false,
  items_by_transfer: [],

  saving_transfer_item: false,
  saved_transfer_item: false,

  adding_quantity_to_transfer_item_ids: [],
  added_quantity_to_transfer_item_ids: [],

  subtracting_quantity_to_transfer_item_ids: [],
  subtracted_quantity_to_transfer_item_ids: [],

  removing_transfer_item_ids: [],
  removed_transfer_item_ids: [],
}

const transferItemsReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_ITEMS_BY_TRANSFER_ID: {
      return {
        ...state,
        loading_items_by_transfer: action.payload.loading,
        items_by_transfer: action.payload.data ?? state.items_by_transfer,
      }
    }
    case Actions.SAVE_TRANSFER_ITEM: {
      return {
        ...state,
        saved_transfer_item: action.payload.saved ?? false,
        saving_transfer_item: action.payload.saving ?? false,
        items_by_transfer: action.payload.data
          ? addOrUpdateObjectInArray(state.items_by_transfer, action.payload.data, 'traslado_detalle_id', true)
          : state.items_by_transfer
      }
    }
    case Actions.ADD_QUANTITY_TO_TRANSFER_ITEM: {
      return {
        ...state,
        adding_quantity_to_transfer_item_ids: toggleIdInArray(state.adding_quantity_to_transfer_item_ids, action.payload.adding_id),
        added_quantity_to_transfer_item_ids: toggleIdInArray(state.added_quantity_to_transfer_item_ids, action.payload.added_id),
        items_by_transfer: action.payload.data
          ? addOrUpdateObjectInArray(state.items_by_transfer, action.payload.data, 'traslado_detalle_id')
          : state.items_by_transfer
      }
    }
    case Actions.SUBTRACT_QUANTITY_TO_TRANSFER_ITEM: {
      return {
        ...state,
        subtracting_quantity_to_transfer_item_ids: toggleIdInArray(state.subtracting_quantity_to_transfer_item_ids, action.payload.subtracting_id),
        subtracted_quantity_to_transfer_item_ids: toggleIdInArray(state.subtracted_quantity_to_transfer_item_ids, action.payload.subtracted_id),
        items_by_transfer: action.payload.data
          ? addOrUpdateObjectInArray(state.items_by_transfer, action.payload.data, 'traslado_detalle_id')
          : state.items_by_transfer
      }
    }
    case Actions.REMOVE_TRANSFER_ITEM: {
      return {
        ...state,
        removing_transfer_item_ids: toggleIdInArray(state.removing_transfer_item_ids, action.payload.removing_id),
        removed_transfer_item_ids: toggleIdInArray(state.removed_transfer_item_ids, action.payload.removed_id),
        items_by_transfer: state.items_by_transfer.filter(item => item.traslado_detalle_id !== action.payload.removed_id)
      }
    }
    default: {
      return state
    }
  }
}
export default transferItemsReducer
